import { useDispatch, useSelector } from "react-redux";
import dynamicfunction from "../../utils/dynamicfunction";
import { getContentKeyAccToLang } from "../../utils/utils";
import { useNavigate } from "react-router";
import { updateVatNumber } from "../../store/actions/settingAction";
import { useEffect, useState } from "react";
import { getClientData } from "../../store/actions/investmentsAction";
import { alphaNumeric } from "../../config/config";
import { X } from "@mui/icons-material";

export default () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { TextWeight, isArabic } = dynamicfunction();
  const { settingContent } = useSelector((state) => state.content);
  const { user } = useSelector((state) => state.common);
  const { settingLoading } = useSelector((state) => state.setting);

  const { clientDetails } = useSelector((state) => state.investments);

  const [vatNumber, setVatNumber] = useState('');
  const [error, setError] = useState("");

  useEffect(() => {
    setVatNumber(clientDetails?.clientInformation?.vatNumber)
  }, [clientDetails])

  const getContentKey = (key) => {
    return getContentKeyAccToLang(
      settingContent?.web_general_setting?.data?.attributes,
      key,
      isArabic
    );
  };

  const handleVatChange = (e) => {
    let value = e.target?.value ?? '';

    if (value === "" || alphaNumeric.test(value)) {
      setVatNumber(value);
      setError("");
    }
  };

  const onSubmit = () => {
    const api_data = {
      vatNumber: vatNumber?.toUpperCase(),
    };

    dispatch(updateVatNumber(api_data, () => {
      dispatch(getClientData())
      navigate(-1)
    }));
  };

  return {
    TextWeight,
    getContentKey,
    navigate,
    isArabic,
    onSubmit,
    settingLoading,
    vatNumber,
    setVatNumber,
    error,
    setError,
    handleVatChange,
  };
};
